import { useContextSelector, createContext } from 'use-context-selector';
import { Report as ReportInterface } from '../../types/report';

export type ReportPageReport =
  | ReportInterface
  | {
      account: { name: string; id?: string };
      brandingName: string;
      displayStatus: string;
      id: string;
      candidate: { email: string } | undefined;
      countyCriminalSearches: Array<any>;
    };

type ReportContextType = ReportPageReport | undefined;

const ReportContext = createContext<ReportContextType>(undefined);

export const useReportSelector = <T,>(
  selector: (report: ReportContextType) => T,
): T => useContextSelector(ReportContext, selector);

export default ReportContext;
